export default {
    G1:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'logo',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }, 
    G2:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'nuestras prioridades', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G3:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'instituto de finanzas sostenibles (en inglés)', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G4:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'viviendas a precios asequibles',
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    S1:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'viviendas', // e.g., "housing" 
        'siteSection': 'viviendas', // e.g., "housing"
    },
    S2:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'la sostenibilidad y el clima', // e.g., "housing" 
        'siteSection': 'la sostenibilidad y el clima', // e.g., "housing"
    },
    S3:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'crecimiento de pequeñas empresas', // e.g., "housing" 
        'siteSection': 'crecimiento de pequeñas empresas', // e.g., "housing"
    },
    S4:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'bienestar financiero', // e.g., "housing" 
        'siteSection': 'bienestar financiero', // e.g., "housing"
    },
    S5:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'map', // e.g., "housing" 
        'siteSection': 'map', // e.g., "housing"
    },
    S6:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'estrategia focalizada para marcar la diferencia en tu comunidad', // e.g., "housing" 
        'siteSection': 'estrategia focalizada para marcar la diferencia en tu comunidad', // e.g., "housing"
    },
    S7:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'footer', // e.g., "housing" 
        'siteSection': 'footer', // e.g., "housing"
    },
    C1:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'viviendas' // e.g., 'housing'
    }, 
    C2:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'la sostenibilidad y el clima' // e.g., 'housing'
    }, 
    C3:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'crecimiento de pequeñas empresas'
    }, 
    C4:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'masthead click',
        'buttonLocation': 'top', 
        'siteSection': 'masthead',
        'clickText': 'bienestar financiero'
    }, 
    C5:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'lowercase user input', // e.g., 'housing'
        'clickText': 'aprende más'
    }, 
    C6:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'bienestar financiero',
        'clickText': 'aportar $50 millones' 
    }, 
    C7:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': 'lowercase user input', // e.g., "90210", "new york", etc.
    }, 
    C8:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': 'lowercase user input', // e.g., "environment"
    }, 
    C9:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'estrategia focalizada',
        'clickText': 'aprende más sobre nuestro proceso de subvenciones (en inglés)' 
    },
    C10:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'crecimiento de pequeñas empresas',
        'clickText': 'connect to more' 
    },
    C16:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'anchor link',
        'clickText': 'map image', // e.g., "environment"
    },
    C18:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'viviendas',
        'clickText': 'viviendas', // e.g., "environment"
    },
    C19:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'la sostenibilidad y el clima',
        'clickText': 'la sostenibilidad y el clima', // e.g., "environment"
    },
    C20:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'crecimiento de pequeñas empresas',
        'clickText': 'crecimiento de pequeñas empresas', // e.g., "environment"
    },
    C21:{
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'anchor link',
        'buttonLocation': 'mid', 
        'siteSection': 'bienestar financiero',
        'clickText': 'bienestar financiero', // e.g., "environment"
    },
};